import { z } from 'zod';

export const academyRecursosSchema = z.object({
  diagnosticos: z.array(z.string()).optional(),
  trilhas: z.array(z.string()).optional(),
  /** Legado: a Mentoria saiu (o Conselheiro a substitui). Aceito e ignorado. */
  mentoring: z.boolean().optional(),
  /** Produto Conselheiro. Quem é sócio, responsável ou
   *  conselheiro vinculado chega pelos dados do cadastro; isto é o plano. */
  conselheiro: z.boolean().optional(),
  ia_assistente: z.boolean().optional(),
  eventos: z.array(z.string()).optional(),
  produtos: z.array(z.string()).optional(),
  expira_em: z.string().datetime().optional().nullable(),
});

export type AcademyRecursos = z.infer<typeof academyRecursosSchema>;

export function parseRecursosHeader(raw: string | undefined): AcademyRecursos | null {
  if (!raw?.trim()) return null;
  try {
    return academyRecursosSchema.parse(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function canAccessDiagnostico(recursos: AcademyRecursos, slug = '5forcas'): boolean {
  const list = recursos.diagnosticos ?? [];
  return list.includes('*') || list.includes(slug);
}

export function canAccessTrilha(recursos: AcademyRecursos, trilhaSlug: string): boolean {
  const list = recursos.trilhas ?? [];
  return list.includes('*') || list.includes(trilhaSlug);
}

export function canAccessIa(recursos: AcademyRecursos): boolean {
  return recursos.ia_assistente === true;
}

/**
 * Soma aos recursos do plano as trilhas que vêm do perfil (a formação do
 * Conselheiro, `Trilha.publico` CONSELHEIRO). Sem plano nenhum, parte do
 * mínimo (o diagnóstico 5 Forças). Quem já tem todas (`*`) fica como está.
 */
export function comTrilhasDoPerfil(recursos: AcademyRecursos | undefined, slugs: string[]): AcademyRecursos | undefined {
  if (!slugs.length) return recursos;
  const base = recursos ?? { diagnosticos: ['5forcas'] };
  const atuais = base.trilhas ?? [];
  if (atuais.includes('*')) return base;
  return { ...base, trilhas: [...new Set([...atuais, ...slugs])] };
}
